import {Component, Input} from '@angular/core';
import {RouterLink} from '@angular/router';
import {DxButtonModule, DxContextMenuModule, DxMenuModule} from 'devextreme-angular';
import * as DevExpress from 'devextreme';
import {TaskLogsComponent} from './task-logs-component/task-logs-component';
import {TaskService} from '../../../services/task-service';
import {TaskDto, TaskStatus} from '../../../model/Task';
import {ItemClickEvent} from 'devextreme/ui/context_menu';

@Component({
  selector: 'navigation',
  imports: [
    DxButtonModule,
    DxMenuModule,
    TaskLogsComponent,
    DxContextMenuModule
  ],
  templateUrl: './navigation-component.html',
  styleUrl: './navigation-component.scss'
})
export class NavigationComponent {

  @Input() page:string = '';

  showTaskPopup: boolean = false;
  showLogs: boolean = false;
  defaultPageSize = 8;
  currentTaskPage = 0;

  logs: TaskDto[] | null = null;
  selectedTask: TaskDto | null = null;
  moreLogs: boolean = false;

  readonly TaskStatus = TaskStatus;

  constructor(private taskService: TaskService){}

  listLogs() {
    this.showLogs = true;
    this.taskService.getTasks(this.defaultPageSize, this.currentTaskPage).subscribe(res => {
      this.logs = res;
    });
  }

  itemClicked($event: ItemClickEvent) {
    const { itemData } = $event;

    this.showTaskPopup = true;
    this.selectedTask = itemData as TaskDto;
  }
}
